<template>
  <div
    class="cm-grid"
    :style="{ left: left + 'px', top: top + 'px' }"
  >
    <span
      v-for="index in Math.floor(width / cellSize)"
      :key="index"
      class="cm-grid__item"
      :style="{ width: cellSize + 'px' }"
    >
    </span>
  </div>
</template>

<script>
export default {
  name: "CmGrid",
  props: {
    cellSize: {
      type: Number,
      default: 50
    },
    width: {
      type: Number,
      default: 656
    },
    left: {
      type: Number,
      default: 0
    },
    top: {
      type: Number,
      default: 0
    }
  }
}
// HOW TO USE
// FOR PARENT SET position: relative and z-index: 2 or higher
</script>

<style lang="scss">
.cm-grid {
  border-left: 1px solid $color_border;
  display: flex;
  height: 190px;
  position: absolute;
  z-index: -1;
  &__item {
    border-right: 1px solid $color_border;
    height: 100%;
    width: 50px;
  }
}
</style>